/**
 * 系统配置
 */
let isDev = process.env.NODE_ENV === 'development';
export default {
  http_timeout: 10000,   //http超时时间
  http: "http://",
  https: "https://",
  webSocketUrl: isDev ? ('ws://localhost:4001/') : ('wss://' + location.host + '/api/'),
  dxCaptchaAppId: "499b86bcfb952978716de4633f078218", //顶象验证码
  //public Bucket 域名
  oosPublicDomain: isDev ? "https://im-space-dev.oss-cn-hangzhou.aliyuncs.com/" : "https://im-space.oss-cn-hangzhou.aliyuncs.com/",
  //oos公共读bucket
  public: {
    accessKeyId: "LTAI5tMJrr9CnSmQ1sYRuSu4",
    accessKeySecret: "OraIcTnfj9F33p1YsitH9IVcNN1P2d",
    bucket: isDev ? "im-space-dev" : "im-space",
    region: "oss-cn-hangzhou",
    secure: true
  },
  //百度地图ak
  baiduMapAK: "m0P3o0oxCesslXzF52vR7q8SgHTEkRte",
  //聊天图片大小限制(512KB)
  sendImgSize: 512 * 1024,
  //聊天文件大小限制(10MB)
  sendFileSize: 10 * 1024 * 1024,
  //说说图片大小限制(512KB)
  imgUploadSize: 512 * 1024,
  //说说视频上传大小限制(50MB)
  videoUploadSize: 50 * 1024 * 1024,
  //oss上传路径前缀
  ossUploadPre: "web-upload/",
  //oss上传参数（非私密性内容，如头像、banner）
  ossUploadOption1: {
    headers: {
      //公共缓存30天
      "Cache-Control": "public",
      "Expires": 2592000,
    }
  },
  //默认banner路径
  defaultBanner: "/static/img/banner/20200923163346.png"
}



// WEBPACK FOOTER //
// ./src/config/setting.js